/**
 * Formats duration in minutes to a readable string
 * @param {number|null|undefined} minutes - Duration in minutes
 * @returns {string} Formatted duration string (e.g., "1h 38m", "98m", "N/A")
 */
export const formatDuration = (minutes) => {
  if (minutes === null || minutes === undefined || minutes === "") {
    return "N/A";
  }

  const totalMinutes = Number(minutes);
  
  if (isNaN(totalMinutes) || totalMinutes < 0) {
    return "N/A";
  }

  if (totalMinutes === 0) {
    return "0m";
  }

  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  if (hours > 0 && mins > 0) {
    return `${hours}h ${mins}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${mins}m`;
  }
};

export default formatDuration;
